import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import firebase from "firebase";
import { AuthContext } from "../../Auth";
import "./style.scss";

const Home = () => {
  const authContext = useContext(AuthContext);
  const [playedCount, setPlayedCount] = useState(
    localStorage.playedCount ? localStorage.playedCount : 0
  );
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState(1);
  const history = useHistory();
  const db = firebase.firestore();
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions());
    db.collection("average")
      .doc("average")
      .get()
      .then((doc) => {
        let cnt = parseInt(
          localStorage.playedCount ? localStorage.playedCount : 0
        );
        const increase = Math.floor(
          (parseInt(doc.data().totalPlayer) - cnt) / 100 + 1
        );
        let interval = setInterval(() => {
          setPlayedCount(cnt);
          if (cnt >= doc.data().totalPlayer) {
            if (cnt % 10 === 0) setPlayedCount(cnt + 1);
            localStorage.playedCount = doc.data().totalPlayer;
            clearInterval(interval);
          }
          cnt += increase;
        }, 10);
      });
    return () => {
      window.removeEventListener("resize", updateWindowDimensions());
    };
  }, []);

  const updateWindowDimensions = () => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);
  };

  const handleClickStart = () => {
    // db.collection("users")
    //   .get()
    //   .then((snapshot) => {
    //     console.log(snapshot.size);
    //   });
    const elem = document.getElementById("root");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }

    if (authContext.currentUser) {
      setLoading(true);
      db.collection("users")
        .doc(authContext.currentUser.email)
        .get()
        .then((doc) => {
          db.collection("users")
            .doc(authContext.currentUser.email)
            .get()
            .then((doc) => {
              if (doc.data().timeLeft) {
                setLoading(false);
                setTimeLeft(doc.data().timeLeft);
                history.push(
                  doc.data().timeLeft > 0 ? "/profile" : "/luckygame"
                );
              } else {
                setLoading(false);
                setTimeLeft(0);
                history.push("/luckygame");
              }
            });
        });
    } else {
      history.push("/signin");
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="home-loader-container">
          <img
            alt="loader"
            src={require(`../../assets/images/SVG/1.svg`)}
            className="loader"
          ></img>
          <div>
            {!timeLeft > 0
              ? "LOADING LUCKY PAD..."
              : "LOADING PROFILE SCREEN..."}
          </div>
        </div>
      ) : (
        <div className="home">
          <div
            className="home-header"
            style={{
              height: height > 567 ? height : "568px",
            }}
          >
            <img
              alt="logo"
              src={require("./../../assets/images/home-logo.svg")}
              className="home-header-logo"
            ></img>
            {/* See how lucky <br />
            you are right now. */}
            {/* (See how lucky you are right now.) */}
            {/* <div className="home-header-playerCount">
              {playedCount} people have tested their luck today
            </div> */}
            <div className="home-header-check">
              Check your daily luck
              <br /> with Lucky7
            </div>
            <div className="home-header-comment">
              Lucky7 is a simple <strong>"Luck Testing Engine"</strong> <br />
              {/* based on the data of all the players who played before you. */}
            </div>
            <button className="home-header-button" onClick={handleClickStart}>
              LET'S GO
            </button>
            <div className="home-header-readmore">
              Or scroll down to read more.
            </div>
          </div>
          <div className="home-body">
            <div className="home-body-question1">How to play?</div>
            <div className="home-body-answer1">
              <div className="home-body-answer1-up">
                You start playing by selecting 7 random fields on your screen.
                <br />
                <br />
                When you do, be relaxed and choose the ones that feel lucky.
              </div>
              <img
                alt="help"
                src={require(`./../../assets/images/${
                  width > 700 ? "hand_desktop.png" : "hand.png"
                }`)}
                className="home-body-answer1-image"
                style={{ width: width + 40 }}
              ></img>
              <div className="home-body-answer1-down">
                In the picture above you can see the Lucky7 game-play.
                <br />
                <br />
                If you change your mind about a selected field, you can simply
                click on it again and it will reset the current field, while you
                can choose a new one.
                <br />
                <br />
                Once you are satisfied with your selection, press the CHECK YOUR
                LUCK.
              </div>
            </div>
            <div className="home-body-question2">How does it work?</div>
            <div className="home-body-answer2">
              <div className="home-body-answer2-question">
                Each field has a random value; from 1 to 49. The number is
                generated right before your eyes, as you press the CHECK YOUR
                LUCK.
                <br />
                <br />
                <br />
              </div>
              <div className="home-body-answer2-group1">
                <img
                  alt="human"
                  src={require("../../assets/images/human.svg")}
                  className="home-body-answer2-group1-human"
                ></img>
                <img
                  alt="logo"
                  src={require("../../assets/images/logo.svg")}
                  className="home-body-answer2-group1-logo"
                ></img>
                <img
                  alt="humans"
                  src={require("../../assets/images/humans.svg")}
                  className="home-body-answer2-group1-humans"
                ></img>
              </div>
              Your selected Lucky7 sum will be compared to the sum of all the
              people that have played before you.
              <br />
              <br />
              <div>
                To your result we will add
                <span
                  style={{
                    color: "#ffcc00",
                    fontWeight: "700",
                    marginLeft: "5px",
                  }}
                >
                  the miliseconds of time on the exact moment you finished the
                  game.
                </span>
              </div>
              <br /> This way, your luck will separate you from players who
              scored the same number as you.
              <br />
              <br />
              <br />
              <br />
              <img
                alt="lucky"
                src={require("../../assets/images/lucky.png")}
              ></img>
              <br />
              <br />
              If your Lucky7 score is <strong>above the average</strong> of
              other luck seekers, consider yourself lucky today.
              <br />
              <br />
              <br />
              <br />
              <img
                alt="lucky"
                src={require("../../assets/images/unlucky.png")}
              ></img>
              <br />
              <br />
              If your Lucky7 score is <strong>below the average</strong>, the
              luck is currently not on your side.
              <br />
              <br />
              <br />
              <br />
              <img
                alt="lucky"
                src={require("../../assets/images/timestamp.svg")}
              ></img>
              <br />
              <br />
              <strong>Milliseconds Time Stamp</strong>
              <br />
              <br />
              If your score was <strong>217</strong> and miliseconds at the
              moment you finish the game were .419 your result will be{" "}
              <strong style={{ color: "#ffcc00" }}>217</strong> +419
              miliseconds.
              <br />
              <br />
              <br />
              <br />
              <img
                alt="lucky"
                src={require("../../assets/images/calc.svg")}
              ></img>
              <br />
              <br />
              You can test your luck once per hour, every hour. <br />
              <br />
              <br />
              <br />
              <br />
              <img
                alt="lucky"
                src={require("../../assets/images/notify.svg")}
              ></img>
              <br />
              <br />
              If you wish, we will send a reminder when you can test your luck
              again.
              <br />
              <br />
              <br />
              <br />
              <strong>READY TO GET LUCKY?</strong>
            </div>
          </div>
          <div className="home-footer">
            <button className="home-footer-button" onClick={handleClickStart}>
              LET'S GO
            </button>
          </div>
        </div>
      )}
    </>
  );
};
export default Home;
